// ✅ Exported for VoltBot access
export const projectData = [
  {
    title: 'A-Pujas a puja website',
    description: 'It is my 1st commercial website with HTML and inline CSS',
    link: 'https://github.com/coderarka2004/apandit.github.io',
  },
  {
    title: 'QUIZ APP',
    description: 'Play quiz with a responsive website',
    link: 'https://react-quiz-koushani.netlify.app/',
  },
  {
    title: 'Low Harmonics E-Type Inverter',
    description: 'Low harmonics Envelop type inverter',
    link: 'https://drive.google.com/drive/folders/1fLQSrejeUq2-1029ulim2Flyp4K2of0d?usp=drive_link',
  },
  {
    title: 'Smart Power Distribution',
    description: 'IoT-enabled energy monitoring and relay distribution.',
    link: 'https://drive.google.com/drive/folders/1-nSU0AlV_oRI8Srfv3Yro-sJrVlppFPH?usp=drive_link',
  },
  {
    title: 'Personal AI Desktop Assistant',
    description: 'An AI-powered assistant built with Python and voice commands to handle desktop tasks like browsing, reading files, and more.',
    link: 'https://github.com/coderarka2004/AI-Desktop-Assistant',
  },
  {
    title: 'ML Cancer Detection Initial Model',
    description: 'Initial version of a deep learning model to classify cancer from medical images using CNN.',
    link: 'https://github.com/coderarka2004/Cancer-Detection-ML',
  },
   {
    title: 'ML LUNG Cancer Detection Model',
    description: 'Advanced version of a deep learning model to classify cancer from medical images using CNN & GradCAM.',
    link: 'https://github.com/coderarka2004/Cancer-Detection-ML',
  },
];
